import { Mail, Phone } from "@mui/icons-material";
import { Chip, Grid, Link } from "@mui/material";
import language from "../../../data/language";

const styles = {
    chip: {
        padding: 2,
        paddingY: 3,
        fontSize: 18
    }
}

interface ContactChipsProps {};

export default function ContactChips(props: ContactChipsProps) {
    return <Grid rowSpacing={4} container justifyContent={"space-around"} alignItems={"center"} maxWidth={{xs: undefined, lg: "600px"}}>
        <Grid pl={0} item xs={12} lg={6} textAlign={"center"}><ContactChip icon={<Mail />} text={language.email} link={`mailto:${language.email}`}/></Grid>
        <Grid pl={0} item xs={12} lg={6} textAlign={"center"}><ContactChip icon={<Phone />} text={language.phone} link={`tel:${language.phone}`} /></Grid>
    </Grid>
}

interface ContactChipProps {
    icon: JSX.Element
    text: string
    link: string
}

function ContactChip(props: ContactChipProps) {
    return <Link href={props.link}><Chip label={props.text} icon={props.icon} color={"primary"}  sx={styles.chip}/></Link>
}